// For Github Pages
// export const root = '/app-name/';

// For Vercel and local development
export const root = "/";
